const LOCALES = [
  'en',
  'fr'
];

export default LOCALES;
